import { isRouteErrorResponse, useRouteError } from "react-router";
import { TriangleAlert } from "lucide-react";
import { Button } from "../../components/ui/Button.js";
import { ApiError } from "../../lib/api.js";

/** Borde de error de las rutas: un fallo de render no deja la pantalla en blanco. */
export function RouteError() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : error instanceof ApiError
      ? error.message
      : error instanceof Error
        ? error.message
        : "Error inesperado.";

  // La regla del AF que frenó la acción viaja en `data-rule` (trazabilidad), no se dibuja.
  const rule = error instanceof ApiError ? error.rule : undefined;

  return (
    <div
      data-rule={rule}
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <TriangleAlert aria-hidden className="size-7 text-danger" />
      <h1 className="font-display text-[22px] font-semibold tracking-tight">Algo se rompió</h1>
      <p className="max-w-[60ch] text-[13px] text-dim">{message}</p>
      <Button variant="primary" onClick={() => window.location.reload()}>
        Recargar
      </Button>
    </div>
  );
}

export default RouteError;
